﻿import {PlayerPrefs} from "../Utils/Unity/PlayerPrefs";
import {MonoBehaviour} from "../Utils/Unity/MonoBehaviour";

const VALUE_FPS60 = "FPS60";
const VALUE_LANGUAGE = "LANGUAGE";
const VALUE_MUSIC = "MUSIC";
const VALUE_SOUND = "SOUND";
const VALUE_VIBRO = "VIBRO";

export class LocalSettings extends MonoBehaviour {
    _FPS60 = false;
    get FPS60() {
        return !!this._FPS60;
    }
    set FPS60(value) {
        value = !!value;
        let changed = value !== this._FPS60;
        this._FPS60 = !!value;
        PlayerPrefs.SetInt(VALUE_FPS60, ~~this._FPS60);
        if (changed) this.emit("SettingsChanged");
    }

    _Language = 0;
    get Language() {
        return ~~this._Language;
    }
    set Language(value) {
        let changed = value !== this._Language;
        this._Language = value;
        PlayerPrefs.SetInt(VALUE_LANGUAGE, ~~this._Language);
        if (changed) this.emit("SettingsChanged");
    }

    _Sound = false;
    get Sound() {
        return !!this._Sound;
    }
    set Sound(value) {
        value = !!value;
        let changed = value !== this._Sound;
        this._Sound = !!value;
        PlayerPrefs.SetInt(VALUE_SOUND, ~~this._Sound);
        if (changed) this.emit("SettingsChanged");
    }

    _Music = false;
    get Music() {
        return !!this._Music;
    }
    set Music(value) {
        value = !!value;
        let changed = value !== this._Music;
        this._Music = !!value;
        PlayerPrefs.SetInt(VALUE_MUSIC, ~~this._Music);
        if (changed) this.emit("SettingsChanged");
    }

    _Vibro = false;
    get Vibro() {
        return !!this._Vibro;
    }
    set Vibro(value) {
        value = !!value;
        let changed = value !== this._Vibro;
        this._Vibro = !!value;
        PlayerPrefs.SetInt(VALUE_VIBRO, ~~this._Vibro);
        if (changed) this.emit("SettingsChanged");
    }

    constructor() {
        super();
        this._FPS60 = !!PlayerPrefs.GetInt(VALUE_FPS60, 1);
        this._Language = PlayerPrefs.GetInt(VALUE_LANGUAGE, 0);
        this._Music = !!PlayerPrefs.GetInt(VALUE_MUSIC, 1);
        this._Sound = !!PlayerPrefs.GetInt(VALUE_SOUND, 1);
        this._Vibro = !!PlayerPrefs.GetInt(VALUE_VIBRO, 1);
        //        Application.targetFrameRate = FPS60 ? 60 : 30;
    }
}
